import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import { useTranslations } from '../../../../hooks/use-translations';

/**
 * Small inline badge shown next to a field that is normally synced from Skillko.
 * Purely informational - rendering is controlled by the caller (only render when
 * the profile is Skillko-sourced and the field is in the critical field list).
 */
const SkillkoFieldBadge = () => {
  const { t } = useTranslations();
  const theme = useTheme();

  return (
    <Tooltip title={t('profiles.form.skillkoFieldBadgeTooltip')} arrow placement="top">
      <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'help', flexShrink: 0 }}>
        <Icon icon="mdi:cloud-sync-outline" width={18} height={18} color={theme.palette.primary.main} />
      </Box>
    </Tooltip>
  );
};

export default SkillkoFieldBadge;
